import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsurancesListModule } from '../insurances-list/insurances-list.module';
import { InsurancesDropdownComponent } from './insurances-dropdown.component';
import {
    WucBalloonModule,
    WucButtonModule,
    WucDropTriggerModule,
    WucExplanationArrowModule
} from '@inshared/website-ui-components';

@NgModule({
    declarations: [
        InsurancesDropdownComponent,
    ],
    imports: [
        CommonModule,
        InsurancesListModule,
        WucButtonModule,
        WucDropTriggerModule,
        WucBalloonModule,
        WucExplanationArrowModule,
    ],
    exports: [
        InsurancesDropdownComponent,
    ],
})
export class InsurancesDropdownModule { }
